/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { UserInviteDtoModel, UserInviteDtoModelType } from "./UserInviteDtoModel"
import { UserInviteDtoModelSelector } from "./UserInviteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  user: UserDtoModelType;
  userInvite: UserInviteDtoModelType;
}

/**
 * UserInviteCreatedDtoBase
 * auto generated base class for the model UserInviteCreatedDtoModel.
 */
export const UserInviteCreatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('UserInviteCreatedDto')
  .props({
    __typename: types.optional(types.literal("UserInviteCreatedDto"), "UserInviteCreatedDto"),
    /** User for the new invite */
    user: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserDtoModel))),
    /** New user invite */
    userInvite: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserInviteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class UserInviteCreatedDtoModelSelector extends QueryBuilder {
  user(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`user`, UserDtoModelSelector, builder) }
  userInvite(builder: string | UserInviteDtoModelSelector | ((selector: UserInviteDtoModelSelector) => UserInviteDtoModelSelector) | undefined) { return this.__child(`userInvite`, UserInviteDtoModelSelector, builder) }
}
export function selectFromUserInviteCreatedDto() {
  return new UserInviteCreatedDtoModelSelector()
}

export const userInviteCreatedDtoModelPrimitives = selectFromUserInviteCreatedDto()
